import { render, staticRenderFns } from "./ChallengesConsole.vue?vue&type=template&id=08f279b6&scoped=true&"
import script from "./ChallengesConsole.vue?vue&type=script&lang=js&"
export * from "./ChallengesConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f279b6",
  null
  
)

export default component.exports